import React, { useEffect,useState } from 'react'
import { Link } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'
import { DatePicker } from 'antd';
import CommonSelect from '../../../core/common/commonSelect';
import { Employee } from '../../../types/dataModel';
import {API, GENDER} from '../../../common/Constants'
import useFetch from '../../../hooks/useFetch';
import PreLoader from '../../../core/common/preLoader';
import DepartmentDropDown from './departmentDropDown';
import { getAPIHeaders, isValidPhoneNumber, isValidEmail, isNotEmpty } from '../../../common/Utils';
import CommonSelectV2 from '../../../core/common/commonSelectV2';

type PasswordField = "password" | "confirmPassword";

interface Props {
  onSuccess: ()=> void
  designations: any[]
  roleOpts: any[]
}

const OnboardEmployee = ({onSuccess, designations, roleOpts}:Props) => {
    const [employee, setEmployee] = useState<Employee>()
    const [errorMessage, setErrorMessage] = useState<string | undefined>("");
    const {isLoading, error, data, status, callFetch } = useFetch();
    const [showMsgBox, setShowMsgBox] = useState<boolean|null>(false)

    useEffect(()=>{
      setShowMsgBox(false)
    },[])

    useEffect(() => {
          if(data && status && status < 299){
              reset();
              setShowMsgBox(true)
              onSuccess()
          }
     }, [status]);

    useEffect(() => {
        if(error){
          if(error.response?.data){
            setErrorMessage(error.response?.data)
          } else{
            setErrorMessage('Something went wrong please try again later.')
          }
        }
    }, [error]);

  const handleSubmit = (event:any) => {
      event.preventDefault()
      if(!isNotEmpty(employee?.departmentId)){
        setErrorMessage("Please select a department")
      } else if(!isNotEmpty(employee?.designationId)){
        setErrorMessage("Please select a designation")
      } else if(!isNotEmpty(employee?.firstName)){
        setErrorMessage("Please provide a first name")
      } else if(!isNotEmpty(employee?.lastName)){
        setErrorMessage("Please provide last name")
      } else if(!employee?.dob){
        setErrorMessage("Please select date of birth")
      } else if(!isValidEmail(employee?.email)){
        setErrorMessage("Please provide a valid email address")
      } else if(!isValidPhoneNumber(employee?.phoneNumber)){
        setErrorMessage("Please provide a valid 10 digits phone number")
      }  else if(!isNotEmpty(employee?.username)){
        setErrorMessage("Please provide a username")
      } else if(employee?.confirmPassword !== employee?.password){
        setErrorMessage("Password and Confirm Password Mismatch")
      } else if(!employee?.roles?.length){
        setErrorMessage("Please select atleast one role")
      } else {
        setErrorMessage("")
        callFetch(API.EMPLOYEE,
            'POST',
            getAPIHeaders(),
            null,
            {
                ...employee,
                roles: employee?.roles?.map((role:any) => role?.label)
            }
        ).catch((error) => {
          if(error?.response?.data){  
            setErrorMessage(error?.response?.data)
          }
        });
      }
    }

    const reset = () => {
      setEmployee(undefined)
    }

    const getModalContainer = () => {
        const modalElement = document.getElementById('modal-datepicker');
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };
    const [passwordVisibility, setPasswordVisibility] = useState({
        password: false,
        confirmPassword: false,
    });

    const togglePasswordVisibility = (field: PasswordField) => {
        setPasswordVisibility((prevState) => ({
        ...prevState,
        [field]: !prevState[field],
        }));
    };

    const renderMsgBox = () => {
      return (          
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center">
              <span className="avatar avatar-xl bg-transparent-success text-success mb-3">
                  <i className="ti ti-thumb-up fs-36" />
              </span>
              <h4 className="mb-1">Employee Onboarding Successfull</h4>
              <p className="mb-3">
                  Employee is onboarded successfully.
              </p>
              <div className="d-flex justify-content-center">
                  <Link to="#" 
                      data-bs-dismiss="modal" 
                      className="btn btn-success"
                      onClick={()=>{
                        setTimeout(() => {
                          setShowMsgBox(false);
                        }, 1000);
                        }}>
                      Close
                  </Link>
              </div>
          </div>
      </div>
    </div>)
    }

    const renderForm = () => {
      return (     
        <div className="modal-dialog modal-dialog-centered modal-lg" >
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Employee</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form action={all_routes.employeeList}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Onboarding Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Department <span className="text-danger"> *</span></label>
                          <DepartmentDropDown
                            defaultDepartment={""}
                            handleChange={(value:any)=>{
                              setEmployee({
                                ...employee,
                                departmentId: parseInt(value)
                            })
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Designation <span className="text-danger"> *</span></label>
                          <CommonSelect
                            className='select'
                            options={designations}
                            onChange={(value)=>{
                              setEmployee({
                                ...employee,
                                designationId: parseInt(value)
                            })
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            First Name <span className="text-danger"> *</span>
                          </label>
                          <input type="text" className="form-control" 
                          value={employee?.firstName}
                          onChange={(e)=>{setEmployee({
                            ...employee,
                            firstName: e.target.value
                          })}}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Last Name <span className="text-danger"> *</span></label>
                          <input type="email" className="form-control" 
                            value={employee?.lastName}
                            onChange={(e)=>{setEmployee({
                              ...employee,
                              lastName: e.target.value
                            })}}/>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Date Of Birth <span className="text-danger"> *</span>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker"
                              format={{
                                format: "DD-MM-YYYY",
                                type: "mask",
                              }}
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              onChange={(value:any)=>{
                                setEmployee({
                                  ...employee,
                                  dob: value?.toDate()?.getTime()/1000
                                })
                              }}
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Gender <span className="text-danger"> *</span></label>
                          <CommonSelect
                            className='select'
                            options={GENDER}
                            onChange={(value)=>{
                              setEmployee({
                                ...employee,
                                gender: value
                            })
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Email <span className="text-danger"> *</span>
                          </label>
                          <input type="email" className="form-control"
                              value={employee?.email}
                              onChange={(e)=>{
                                setEmployee({
                                ...employee,
                                email: e.target.value
                                })}} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone Number <span className="text-danger"> *</span>
                          </label>
                          <input 
                            type="text" 
                            className="form-control" 
                            value={employee?.phoneNumber}
                            onChange={(e) => {
                              const numericValue = e.target?.value // ?.replace(/\D/g, '');
                              setEmployee({
                              ...employee,
                              phoneNumber: numericValue ? parseInt(numericValue) : undefined
                              });
                            }}
                            onKeyPress={(e) => {
                              // Allow only numeric input
                              if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">
                              Roles <span className="text-danger"> *</span>
                            </label>
                            <CommonSelectV2 
                              isMulti 
                              options={roleOpts}
                              values={employee?.roles?.length ? employee?.roles : null}
                              onChange={(value: any[]) => {
                                  let newRoles: any[] = value?.map((v: string) => {
                                    return roleOpts?.find((role: any) => role?.value === v)
                                  })
                                  setEmployee({
                                    ...employee,
                                    roles: [...newRoles]
                                  })
                              }}
                            />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Username <span className="text-danger"> *</span>
                          </label>
                          <input type="text" className="form-control" 
                              value={employee?.username}
                              onChange={(e)=>{
                                setEmployee({
                                ...employee,
                                username: e.target.value
                                })}}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 ">
                          <label className="form-label">
                            Password <span className="text-danger"> *</span>
                          </label>
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.password
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                              value={employee?.password}
                              onChange={(e)=>{
                                setEmployee({
                                ...employee,
                                password: e.target.value
                                })}}
                            />
                            <span
                              className={`ti toggle-passwords ${passwordVisibility.password
                                ? "ti-eye"
                                : "ti-eye-off"
                                }`}
                              onClick={() =>
                                togglePasswordVisibility("password")
                              }
                            ></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 ">
                          <label className="form-label">
                            Confirm Password <span className="text-danger"> *</span>
                          </label>
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.confirmPassword
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                              value={employee?.confirmPassword}
                              onChange={(e)=>{
                                setEmployee({
                                ...employee,
                                confirmPassword: e.target.value
                                })}}
                            />
                            <span
                              className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                ? "ti-eye"
                                : "ti-eye-off"
                                }`}
                              onClick={() =>
                                togglePasswordVisibility("confirmPassword")
                              }
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer" style={{ justifyContent: "space-between"}}>
                    <div>
                      { errorMessage  ?
                        <>
                          <i className="ti ti-alert-triangle text-danger" />  
                          <span className='text-danger'> {errorMessage} </span> 
                        </> 
                        : <></>
                      }
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-outline-light border me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="button" 
                        className="btn btn-primary" 
                        onClick={handleSubmit}>
                        Save{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )
    }

    return (
      <div className="modal fade" id="add_employee"                
      data-bs-backdrop="static"
      data-bs-keyboard="false">
        <PreLoader showLoader={isLoading} />
        {showMsgBox ? renderMsgBox() : renderForm()}
      </div>
    )
}

export default OnboardEmployee